import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getTutorNotificationListData } from '../../../Redux/action/TutorAction';
import { useDispatch, useSelector } from 'react-redux';
import Beatloader from '../../../Common/BeatLoader';
import TutorSidebar from '../TutorSidebar/TutorSidebar'
import ResponsivePagination from '../../../Common/Pagination';


const TutorNotification = () => {

    const dispatch = useDispatch();

    useEffect(() => {


        dispatch(getTutorNotificationListData());


    }, []);


    const {

        loadingTutorNotificationListApi,
        TutorNotificationListApiData,
        TutorNotificationListApiError

    } = useSelector(state => state?.TutorReducer);

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


    //pagination
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1); // ✅ 1-based page index
    const dataPerPage = 10;

    useEffect(() => {
        if (!TutorNotificationListApiData) return;

        const start = (currentPage - 1) * dataPerPage;
        const end = start + dataPerPage;

        setCurrentData(TutorNotificationListApiData.slice(start, end));
        setPageCount(Math.ceil(TutorNotificationListApiData.length / dataPerPage));
    }, [currentPage, dataPerPage, TutorNotificationListApiData]);

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo(0, 0);
    };

    return (
        <div className='pagination-component'>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Notification
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorNotificationListApi ?
                                    <Beatloader />
                                    :
                                    <div className="notification-sec">
                                        <h4 className="mb-3">Notification</h4>
                                        {TutorNotificationListApiData?.length > 0 ?
                                            currentData?.map((data) => (
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-lg-2">
                                                                <div className="card bg-primary">
                                                                    <div className="card-body text-white">
                                                                        <h5 className="text-center text-white  mb-0">{new Date(data?.createdAt).getUTCDate()}</h5>
                                                                        <h5 className="text-center text-white mb-0">{monthNames[new Date(data?.createdAt).getUTCMonth()]}</h5>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-10 d-flex align-content-center flex-lg-wrap">
                                                                {/* <h5 className="mt-2">student_request_rejected_by_tutor</h5> */}
                                                                <p>{data?.message}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                            :
                                            <div className='no-data-img'>
                                                <img width={100} src="/assets/img/user/silent.png" alt="" srcset="" />

                                            </div>}

                                        {pageCount > 1 && (
                                            <ResponsivePagination
                                                pageCount={pageCount}
                                                currentPage={currentPage}
                                                handlePageClick={handlePageClick}
                                            />
                                        )}

                                    </div>}
                            </main>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

export default TutorNotification